import Header from "./Landing-Page/HeaderSection";
import FinfuzeIntro from "./Landing-Page/Finfuze-intro";
import About from "./Landing-Page/AboutSection";
import Footer from "./Landing-Page/FooterSection";

function LandingPage() {
  return (
    <>
    <Header/>
    <FinfuzeIntro/>
    <About/>
    <Footer/>
    </>
  );
}

export default LandingPage;
